const NavigationEmail = () => {
	return <p className="myemail-txt">&lt; / berkbeleli@gmail.com &gt;</p>;
  };
  
  export default NavigationEmail;